import React, { useEffect, useState } from "react";
import { Button, Input, Select, Table, Tooltip } from "antd";
import axios from "axios";
import config from "../../../config";
import authHeader from "../../Authentication/authHeader";
import Swal from "sweetalert2";
import { EyeOutlined } from "@ant-design/icons";
import { DatePicker } from "antd";
import dayjs from "dayjs";

export default function ProductReceiveListReport({ tabChange }) {
  const { Search } = Input;
  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const [stockList, setStockList] = useState([]);
  const [centerList, setCenterList] = useState([]);
  const [centerIds, setCenterIds] = useState([]);
  const [stockLoading, setStockLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [search, setSearch] = useState("");
  const [selectedCenter, setSelectedCenter] = useState("");
  const [userProfile, setUserProfile] = useState(
    JSON.parse(localStorage.getItem("userProfile"))
  );
  const [selectedDateRange, setSelectedDateRange] = useState([]);

  const handleReceiveDateRage = (value) => {
    setCurrentPage(1);
    if (value?.length === 2) {
      const startDate = dayjs(value[0]).startOf("day");
      const endDate = dayjs(value[1]).endOf("day");
      const updatedDateRange = [startDate, endDate];
      setSelectedDateRange(updatedDateRange);
    } else {
      setSelectedDateRange(null);
    }
  };

  const handleSearch = (value) => {
    setCurrentPage(1);
    setSearch(value);
  };
  const handleCenter = (value) => {
    setCurrentPage(1);
    setSelectedCenter(value);
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const fetchStockList = () => {
    setStockLoading(true);
    axios
      .get(
        `${config.baseUrl}/inventory/stock_list/${userProfile?.employee_id}/`,
        {
          headers: authHeader(),
          params: {
            search: search,
            searched_center_id: selectedCenter,
            dateRange: selectedDateRange,
            page: currentPage,
          },
        }
      )
      .then((response) => {
        setStockLoading(false);
        setStockList(response?.data?.results);
        setTotalItems(response?.data?.count);
      })
      .catch((error) => {
        setStockLoading(false);
        console.log(error);
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  };
  useEffect(() => {
    fetchStockList();
  }, [currentPage, search, selectedCenter, selectedDateRange, tabChange]);

  useEffect(() => {
    setStockLoading(true);
    axios
      .get(`${config.baseUrl}/inventory/center_list/`, {
        headers: authHeader(),
      })
      .then((response) => {
        setStockLoading(false);
        setCenterList(response?.data);
        const employeeIds = response?.data?.map(
          (center) => center?.center?.employee_id
        );
        setCenterIds(employeeIds);
      })
      .catch((error) => {
        setStockLoading(true);
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  }, []);

  const stockColumn = [
    {
      title: "Date",
      render: (record) =>
        record?.receive_date
          ? new Date(record?.receive_date).toISOString().slice(0, 10)
          : "",
      width: "5%",
    },
    {
      title: "Center",
      render: (record) => record?.center?.center_name,
      width: "5%",
    },
    {
      title: "Supplier Name",
      render: (record) => record?.supplier_details?.supplier_name,
      width: "10%",
    },
    {
      title: "GRN",
      dataIndex: "grn",
      width: "4%",
    },
    {
      title: "Challan",
      dataIndex: "challan",
      width: "5%",
    },
    {
      title: "Product Name",
      render: (record) => record?.product?.product_name,
      width: "8%",
    },
    {
      title: "Batch",
      dataIndex: "batch_id",
      width: "7%",
    },
    centerIds?.includes(userProfile?.employee_id) ? (
      <></>
    ) : (
      {
        title: "Rate",
        render: (record) => (
          Number(record?.purchase_price?.toFixed(2)).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        ),
        width: "5%",
      }
    ),
    {
      title: "In",
      render: (record) => record?.stock_in?.toLocaleString(),
      width: "4%",
    },
    {
      title: "Out",
      render: (record) => record?.stock_out?.toLocaleString(),
      width: "4%",
    },
    {
      title: "Remaining",
      render: (record) => record?.stock?.toLocaleString(),
      width: "5%",
    },
    centerIds?.includes(userProfile?.employee_id) ? (
      <></>
    ) : (
      {
        title: "Stock Value",
        render: (record) => {
          const value = Number(record?.purchase_price) * Number(record?.stock);

          return Number(value.toFixed(2)).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        },
        width: "5%",
      }
    ),
  ];
  return (
    <>
      <div className="farmerDashboard">
        <div className="shadow-sm p-3">
          <div className="m-2 mt-4 d-flex justify-content-between align-items-center">
            <div>
              {centerIds?.includes(userProfile?.employee_id) ? null : (
                <Select
                  placeholder="Select Center"
                  className="me-3"
                  onChange={handleCenter}
                  style={{ width: "200px" }}
                >
                  <Option value="">All Center</Option>
                  {centerList?.map((center) => (
                    <Option
                      value={center?.center?.employee_id}
                      key={center?.center?.employee_id}
                    >
                      {center?.center_name}
                    </Option>
                  ))}
                </Select>
              )}
              <RangePicker
                onChange={handleReceiveDateRage}
                value={selectedDateRange}
                style={{ width: "320px" }}
              />
            </div>
            <Search
              className="w-25"
              placeholder="search here..."
              allowClear
              onSearch={handleSearch}
              enterButton={
                <Button
                  style={{
                    backgroundColor: "#46604A",
                    borderColor: "#46604A",
                    color: "white",
                  }}
                >
                  Search
                </Button>
              }
            />
          </div>
          <Table
            className="border"
            columns={stockColumn}
            dataSource={stockList}
            loading={stockLoading}
            size="small"
            rowKey={(record) => record.id}
            pagination={{
              current: currentPage,
              pageSize: 10,
              total: totalItems,
              onChange: handlePageChange,
            }}
          />
        </div>
      </div>
    </>
  );
}
